import type { ReactNode } from 'react';
import { X } from 'lucide-react';

import { DialogTitle } from '@/shared/widgets/dialog';
import { cn } from '@/shared/utils/cn';

interface PopupCardProps {
  title: ReactNode;
  children: ReactNode;
  onClose?: () => void;
  headerBgClassName?: string;
  titleBgColor?: string;
  titleClassName?: string;
  className?: string;
  bodyClassName?: string;
}

export function PopupCard({
  title,
  children,
  onClose,
  headerBgClassName = 'bg-brand text-white',
  titleBgColor,
  titleClassName = '',
  className,
  bodyClassName,
}: PopupCardProps) {
  return (
    <div className={cn('flex flex-col overflow-hidden rounded-lg font-secondary min-w-0', className)}>
      <header
        className={cn(
          'relative flex items-center justify-start px-6 py-4',
          headerBgClassName,
        )}
        style={titleBgColor ? { backgroundColor: `var(${titleBgColor})` } : undefined}
      >
        <DialogTitle className={cn(
          'text-lg font-semibold tracking-wide',
          titleClassName,
        )}>
          {title}
        </DialogTitle>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-1/2 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded hover:bg-white/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-white/80 focus-visible:ring-offset-brand"
            aria-label="Close"
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        )}
      </header>

      <div
        className={cn(
          'flex flex-col gap-6 bg-white px-6 py-6 md:px-8 md:py-8',
          bodyClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}

